import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeathersService } from '../services/api/feathers.service';
import { TranslateLoader } from '@ngx-translate/core';
import { defer, Observable, tap } from 'rxjs';

@Component({
  template: '',
  standalone: true,
  imports: [CommonModule],
})
export class TranslationCustomLoaderComponent implements TranslateLoader {
  private readonly feathers = inject(FeathersService);

  getTranslation(lang: string): Observable<any> {
    return defer(() => import(`src/assets/i18n/${lang}.json`)).pipe(
      tap((translation) => this.feathers.loadedTranslation.next(translation))
    );
  }
}
